import { EnumValues } from '@/services/types/EnumValues';

/**
 * What a refetched multi-sign action turned out to be once a stale approve/reject call hits a
 * 4100/4103 conflict - see reconcileAfterAuthorisationConflict in useScheduledPaymentAction and
 * AlreadyActionedModal, which renders one of these.
 */
export const AlreadyActionedOutcomeEnum = {
  APPROVED: 'approved',
  // The action is fully approved, and it was this customer's own authorisation (e.g. from the
  // mobile app) that did it.
  APPROVED_BY_YOU: 'approved_by_you',
  // This customer approved from another device, but the rule still needs other signers.
  APPROVED_PENDING_BY_YOU: 'approved_pending_by_you',
  REJECTED: 'rejected',
  REJECTED_BY_YOU: 'rejected_by_you',
  EXPIRED: 'expired'
} as const;
export type TAlreadyActionedOutcome = EnumValues<typeof AlreadyActionedOutcomeEnum>;
